import { render, staticRenderFns } from "./SettingPromotionLocalProductNew.vue?vue&type=template&id=7068e9c9&"
import script from "./SettingPromotionLocalProductNew.vue?vue&type=script&lang=js&"
export * from "./SettingPromotionLocalProductNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports